import { baseApiClient as api } from "../baseService";

export const addTagTypes = ["subjects", "parties"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      animalsList: build.query<AnimalsListApiResponse, AnimalsListApiArg>({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/animals/`,
        }),
        providesTags: ["subjects"],
      }),
      animalsCreate: build.mutation<
        AnimalsCreateApiResponse,
        AnimalsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/animals/`,
          method: "POST",
          body: queryArg.createAnimal,
        }),
        invalidatesTags: ["subjects"],
      }),
      animalsRetrieve: build.query<
        AnimalsRetrieveApiResponse,
        AnimalsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/animals/${queryArg.id}/`,
        }),
        providesTags: ["subjects"],
      }),
      animalsUpdate: build.mutation<
        AnimalsUpdateApiResponse,
        AnimalsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/animals/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedUpdateAnimal,
        }),
        invalidatesTags: ["subjects"],
      }),
      animalsDelete: build.mutation<
        AnimalsDeleteApiResponse,
        AnimalsDeleteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/animals/${queryArg.id}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["subjects"],
      }),
      animalsApproveField: build.mutation<
        AnimalsApproveFieldApiResponse,
        AnimalsApproveFieldApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/animals/${queryArg.id}/approve-field/`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["subjects"],
      }),
      animalsWithSuggestion: build.query<
        AnimalsWithSuggestionApiResponse,
        AnimalsWithSuggestionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/animals/${queryArg.id}/with-suggestion/`,
        }),
        providesTags: ["subjects"],
      }),
      employmentsList: build.query<
        EmploymentsListApiResponse,
        EmploymentsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/employments/`,
        }),
        providesTags: ["parties"],
      }),
      employmentsCreate: build.mutation<
        EmploymentsCreateApiResponse,
        EmploymentsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/employments/`,
          method: "POST",
          body: queryArg.createEmployment,
        }),
        invalidatesTags: ["parties"],
      }),
      employmentsRetrieve: build.query<
        EmploymentsRetrieveApiResponse,
        EmploymentsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/employments/${queryArg.id}/`,
        }),
        providesTags: ["parties"],
      }),
      employmentsUpdate: build.mutation<
        EmploymentsUpdateApiResponse,
        EmploymentsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/employments/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedUpdateEmployment,
        }),
        invalidatesTags: ["parties"],
      }),
      employmentsDelete: build.mutation<
        EmploymentsDeleteApiResponse,
        EmploymentsDeleteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/employments/${queryArg.id}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["parties"],
      }),
      ownershipsList: build.query<
        OwnershipsListApiResponse,
        OwnershipsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/ownerships/`,
        }),
        providesTags: ["subjects"],
      }),
      ownershipsCreate: build.mutation<
        OwnershipsCreateApiResponse,
        OwnershipsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/ownerships/`,
          method: "POST",
          body: queryArg.createOwnership,
        }),
        invalidatesTags: ["subjects"],
      }),
      ownershipsRetrieve: build.query<
        OwnershipsRetrieveApiResponse,
        OwnershipsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/ownerships/${queryArg.id}/`,
        }),
        providesTags: ["subjects"],
      }),
      ownershipsUpdate: build.mutation<
        OwnershipsUpdateApiResponse,
        OwnershipsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/ownerships/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedUpdateOwnership,
        }),
        invalidatesTags: ["subjects"],
      }),
      ownershipsDelete: build.mutation<
        OwnershipsDeleteApiResponse,
        OwnershipsDeleteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/ownerships/${queryArg.id}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["subjects"],
      }),
      personalRelationshipsList: build.query<
        PersonalRelationshipsListApiResponse,
        PersonalRelationshipsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/personal-relationships/`,
        }),
        providesTags: ["parties"],
      }),
      personalRelationshipsCreate: build.mutation<
        PersonalRelationshipsCreateApiResponse,
        PersonalRelationshipsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/personal-relationships/`,
          method: "POST",
          body: queryArg.createPersonalRelationship,
        }),
        invalidatesTags: ["parties"],
      }),
      personalRelationshipsRetrieve: build.query<
        PersonalRelationshipsRetrieveApiResponse,
        PersonalRelationshipsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/personal-relationships/${queryArg.id}/`,
        }),
        providesTags: ["parties"],
      }),
      personalRelationshipsUpdate: build.mutation<
        PersonalRelationshipsUpdateApiResponse,
        PersonalRelationshipsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/personal-relationships/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedUpdatePersonalRelationship,
        }),
        invalidatesTags: ["parties"],
      }),
      personalRelationshipsDelete: build.mutation<
        PersonalRelationshipsDeleteApiResponse,
        PersonalRelationshipsDeleteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/personal-relationships/${queryArg.id}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["parties"],
      }),
      propertiesList: build.query<
        PropertiesListApiResponse,
        PropertiesListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/properties/`,
        }),
        providesTags: ["subjects"],
      }),
      propertiesCreate: build.mutation<
        PropertiesCreateApiResponse,
        PropertiesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/properties/`,
          method: "POST",
          body: queryArg.createProperty,
        }),
        invalidatesTags: ["subjects"],
      }),
      propertiesRetrieve: build.query<
        PropertiesRetrieveApiResponse,
        PropertiesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/properties/${queryArg.id}/`,
        }),
        providesTags: ["subjects"],
      }),
      propertiesUpdate: build.mutation<
        PropertiesUpdateApiResponse,
        PropertiesUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/properties/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedUpdateProperty,
        }),
        invalidatesTags: ["subjects"],
      }),
      propertiesDelete: build.mutation<
        PropertiesDeleteApiResponse,
        PropertiesDeleteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/properties/${queryArg.id}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["subjects"],
      }),
      propertiesApproveField: build.mutation<
        PropertiesApproveFieldApiResponse,
        PropertiesApproveFieldApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/properties/${queryArg.id}/approve-field/`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["subjects"],
      }),
      propertiesWithOwners: build.query<
        PropertiesWithOwnersApiResponse,
        PropertiesWithOwnersApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/properties/${queryArg.id}/with-owners/`,
        }),
        providesTags: ["subjects"],
      }),
      propertiesWithSuggestion: build.query<
        PropertiesWithSuggestionApiResponse,
        PropertiesWithSuggestionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/properties/${queryArg.id}/with-suggestion/`,
        }),
        providesTags: ["subjects"],
      }),
      allSubjectsList: build.query<
        AllSubjectsListApiResponse,
        AllSubjectsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/subjects/`,
        }),
        providesTags: ["subjects"],
      }),
      allSubjectsWithRelationships: build.query<
        AllSubjectsWithRelationshipsApiResponse,
        AllSubjectsWithRelationshipsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/subjects/with-relationships/`,
        }),
        providesTags: ["subjects"],
      }),
      vehicleOccupanciesList: build.query<
        VehicleOccupanciesListApiResponse,
        VehicleOccupanciesListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/vehicle-occupancies/`,
        }),
        providesTags: ["subjects"],
      }),
      vehicleOccupanciesCreate: build.mutation<
        VehicleOccupanciesCreateApiResponse,
        VehicleOccupanciesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/vehicle-occupancies/`,
          method: "POST",
          body: queryArg.createVehicleOccupancy,
        }),
        invalidatesTags: ["subjects"],
      }),
      vehicleOccupanciesRetrieve: build.query<
        VehicleOccupanciesRetrieveApiResponse,
        VehicleOccupanciesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/vehicle-occupancies/${queryArg.id}/`,
        }),
        providesTags: ["subjects"],
      }),
      vehicleOccupanciesUpdate: build.mutation<
        VehicleOccupanciesUpdateApiResponse,
        VehicleOccupanciesUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/vehicle-occupancies/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedUpdateVehicleOccupancy,
        }),
        invalidatesTags: ["subjects"],
      }),
      vehicleOccupanciesDelete: build.mutation<
        VehicleOccupanciesDeleteApiResponse,
        VehicleOccupanciesDeleteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/vehicle-occupancies/${queryArg.id}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["subjects"],
      }),
      vehiclesList: build.query<VehiclesListApiResponse, VehiclesListApiArg>({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/vehicles/`,
        }),
        providesTags: ["subjects"],
      }),
      vehiclesCreate: build.mutation<
        VehiclesCreateApiResponse,
        VehiclesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/vehicles/`,
          method: "POST",
          body: queryArg.createVehicle,
        }),
        invalidatesTags: ["subjects"],
      }),
      vehiclesRetrieve: build.query<
        VehiclesRetrieveApiResponse,
        VehiclesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/vehicles/${queryArg.id}/`,
        }),
        providesTags: ["subjects"],
      }),
      vehiclesUpdate: build.mutation<
        VehiclesUpdateApiResponse,
        VehiclesUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/vehicles/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedUpdateVehicle,
        }),
        invalidatesTags: ["subjects"],
      }),
      vehiclesDelete: build.mutation<
        VehiclesDeleteApiResponse,
        VehiclesDeleteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/vehicles/${queryArg.id}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["subjects"],
      }),
      vehiclesApproveField: build.mutation<
        VehiclesApproveFieldApiResponse,
        VehiclesApproveFieldApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/vehicles/${queryArg.id}/approve-field/`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["subjects"],
      }),
      vehiclesWithOccupants: build.query<
        VehiclesWithOccupantsApiResponse,
        VehiclesWithOccupantsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/vehicles/${queryArg.id}/with-occupants/`,
        }),
        providesTags: ["subjects"],
      }),
      vehiclesWithSuggestion: build.query<
        VehiclesWithSuggestionApiResponse,
        VehiclesWithSuggestionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/vehicles/${queryArg.id}/with-suggestion/`,
        }),
        providesTags: ["subjects"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as enhancedApi };
export type AnimalsListApiResponse = /** status 200  */ ReadAnimal[];
export type AnimalsListApiArg = {
  matterId: string;
};
export type AnimalsCreateApiResponse = /** status 201  */ ReadAnimal;
export type AnimalsCreateApiArg = {
  matterId: string;
  createAnimal: CreateAnimal;
};
export type AnimalsRetrieveApiResponse = /** status 200  */ ReadAnimal;
export type AnimalsRetrieveApiArg = {
  id: string;
  matterId: string;
};
export type AnimalsUpdateApiResponse = /** status 200  */ ReadAnimal;
export type AnimalsUpdateApiArg = {
  id: string;
  matterId: string;
  patchedUpdateAnimal: UpdateAnimal;
};
export type AnimalsDeleteApiResponse = unknown;
export type AnimalsDeleteApiArg = {
  id: string;
  matterId: string;
};
export type AnimalsApproveFieldApiResponse = /** status 200  */ ReadAnimal;
export type AnimalsApproveFieldApiArg = {
  id: string;
  matterId: string;
  body: Blob;
};
export type AnimalsWithSuggestionApiResponse =
  /** status 200  */ ReadAnimalWithSuggestion;
export type AnimalsWithSuggestionApiArg = {
  id: string;
  matterId: string;
};
export type EmploymentsListApiResponse = /** status 200  */ ReadEmployment[];
export type EmploymentsListApiArg = {
  matterId: string;
};
export type EmploymentsCreateApiResponse = /** status 201  */ ReadEmployment;
export type EmploymentsCreateApiArg = {
  matterId: string;
  createEmployment: CreateEmployment;
};
export type EmploymentsRetrieveApiResponse = /** status 200  */ ReadEmployment;
export type EmploymentsRetrieveApiArg = {
  id: string;
  matterId: string;
};
export type EmploymentsUpdateApiResponse = /** status 200  */ ReadEmployment;
export type EmploymentsUpdateApiArg = {
  id: string;
  matterId: string;
  patchedUpdateEmployment: UpdateEmployment;
};
export type EmploymentsDeleteApiResponse = unknown;
export type EmploymentsDeleteApiArg = {
  id: string;
  matterId: string;
};
export type OwnershipsListApiResponse = /** status 200  */ ReadOwnership[];
export type OwnershipsListApiArg = {
  matterId: string;
};
export type OwnershipsCreateApiResponse = /** status 201  */ ReadOwnership;
export type OwnershipsCreateApiArg = {
  matterId: string;
  createOwnership: CreateOwnership;
};
export type OwnershipsRetrieveApiResponse = /** status 200  */ ReadOwnership;
export type OwnershipsRetrieveApiArg = {
  id: string;
  matterId: string;
};
export type OwnershipsUpdateApiResponse = /** status 200  */ ReadOwnership;
export type OwnershipsUpdateApiArg = {
  id: string;
  matterId: string;
  patchedUpdateOwnership: UpdateOwnership;
};
export type OwnershipsDeleteApiResponse = unknown;
export type OwnershipsDeleteApiArg = {
  id: string;
  matterId: string;
};
export type PersonalRelationshipsListApiResponse =
  /** status 200  */ ReadPersonalRelationship[];
export type PersonalRelationshipsListApiArg = {
  matterId: string;
};
export type PersonalRelationshipsCreateApiResponse =
  /** status 201  */ ReadPersonalRelationship;
export type PersonalRelationshipsCreateApiArg = {
  matterId: string;
  createPersonalRelationship: CreatePersonalRelationship;
};
export type PersonalRelationshipsRetrieveApiResponse =
  /** status 200  */ ReadPersonalRelationship;
export type PersonalRelationshipsRetrieveApiArg = {
  id: string;
  matterId: string;
};
export type PersonalRelationshipsUpdateApiResponse =
  /** status 200  */ ReadPersonalRelationship;
export type PersonalRelationshipsUpdateApiArg = {
  id: string;
  matterId: string;
  patchedUpdatePersonalRelationship: UpdatePersonalRelationship;
};
export type PersonalRelationshipsDeleteApiResponse = unknown;
export type PersonalRelationshipsDeleteApiArg = {
  id: string;
  matterId: string;
};
export type PropertiesListApiResponse = /** status 200  */ ReadProperty[];
export type PropertiesListApiArg = {
  matterId: string;
};
export type PropertiesCreateApiResponse = /** status 201  */ ReadProperty;
export type PropertiesCreateApiArg = {
  matterId: string;
  createProperty: CreateProperty;
};
export type PropertiesRetrieveApiResponse = /** status 200  */ ReadProperty;
export type PropertiesRetrieveApiArg = {
  id: string;
  matterId: string;
};
export type PropertiesUpdateApiResponse = /** status 200  */ ReadProperty;
export type PropertiesUpdateApiArg = {
  id: string;
  matterId: string;
  patchedUpdateProperty: UpdateProperty;
};
export type PropertiesDeleteApiResponse = unknown;
export type PropertiesDeleteApiArg = {
  id: string;
  matterId: string;
};
export type PropertiesApproveFieldApiResponse = /** status 200  */ ReadProperty;
export type PropertiesApproveFieldApiArg = {
  id: string;
  matterId: string;
  body: Blob;
};
export type PropertiesWithOwnersApiResponse =
  /** status 200  */ ReadPropertyWithOwners;
export type PropertiesWithOwnersApiArg = {
  id: string;
  matterId: string;
};
export type PropertiesWithSuggestionApiResponse =
  /** status 200  */ ReadPropertyWithSuggestion;
export type PropertiesWithSuggestionApiArg = {
  id: string;
  matterId: string;
};
export type AllSubjectsListApiResponse =
  /** status 200  */ AllSubjectsResponse[];
export type AllSubjectsListApiArg = {
  matterId: string;
};
export type AllSubjectsWithRelationshipsApiResponse =
  /** status 200  */ AllSubjectsWithRelationships;
export type AllSubjectsWithRelationshipsApiArg = {
  matterId: string;
};
export type VehicleOccupanciesListApiResponse =
  /** status 200  */ ReadVehicleOccupancy[];
export type VehicleOccupanciesListApiArg = {
  matterId: string;
};
export type VehicleOccupanciesCreateApiResponse =
  /** status 201  */ ReadVehicleOccupancy;
export type VehicleOccupanciesCreateApiArg = {
  matterId: string;
  createVehicleOccupancy: CreateVehicleOccupancy;
};
export type VehicleOccupanciesRetrieveApiResponse =
  /** status 200  */ ReadVehicleOccupancy;
export type VehicleOccupanciesRetrieveApiArg = {
  id: string;
  matterId: string;
};
export type VehicleOccupanciesUpdateApiResponse =
  /** status 200  */ ReadVehicleOccupancy;
export type VehicleOccupanciesUpdateApiArg = {
  id: string;
  matterId: string;
  patchedUpdateVehicleOccupancy: UpdateVehicleOccupancy;
};
export type VehicleOccupanciesDeleteApiResponse = unknown;
export type VehicleOccupanciesDeleteApiArg = {
  id: string;
  matterId: string;
};
export type VehiclesListApiResponse = /** status 200  */ ReadVehicle[];
export type VehiclesListApiArg = {
  matterId: string;
};
export type VehiclesCreateApiResponse = /** status 201  */ ReadVehicle;
export type VehiclesCreateApiArg = {
  matterId: string;
  createVehicle: CreateVehicle;
};
export type VehiclesRetrieveApiResponse = /** status 200  */ ReadVehicle;
export type VehiclesRetrieveApiArg = {
  id: string;
  matterId: string;
};
export type VehiclesUpdateApiResponse = /** status 200  */ ReadVehicle;
export type VehiclesUpdateApiArg = {
  id: string;
  matterId: string;
  patchedUpdateVehicle: UpdateVehicle;
};
export type VehiclesDeleteApiResponse = unknown;
export type VehiclesDeleteApiArg = {
  id: string;
  matterId: string;
};
export type VehiclesApproveFieldApiResponse = /** status 200  */ ReadVehicle;
export type VehiclesApproveFieldApiArg = {
  id: string;
  matterId: string;
  body: Blob;
};
export type VehiclesWithOccupantsApiResponse =
  /** status 200  */ ReadVehicleWithOccupants;
export type VehiclesWithOccupantsApiArg = {
  id: string;
  matterId: string;
};
export type VehiclesWithSuggestionApiResponse =
  /** status 200  */ ReadVehicleWithSuggestion;
export type VehiclesWithSuggestionApiArg = {
  id: string;
  matterId: string;
};
export type FieldSuggestionMetadata = {
  /** The field name that was accepted (e.g., 'first_name', 'ssn'). */
  field_key: string;
  /** ID of the user who accepted this field. */
  set_by_user_id?: (string | string) | null;
  /** Timestamp when this field was accepted. */
  set_at?: string | null;
};
export type EntitySidecar = {
  /** List of individually accepted fields. */
  field_suggestions: FieldSuggestionMetadata[];
};
export type ReadAnimal = {
  short_description?: string | null;
  involvement_description?: string | null;
  name?: string | null;
  species?: string | null;
  description?: string | null;
  id: string | string;
  matter_id: string | string;
  created_at: string;
  modified_at: string;
  approval_metadata?: EntitySidecar;
};
export type CreateAnimal = {
  short_description?: string | null;
  involvement_description?: string | null;
  name?: string | null;
  species?: string | null;
  description?: string | null;
  matter_id: string | string;
};
export type UpdateAnimal = {
  short_description?: string | null;
  involvement_description?: string | null;
  name?: string | null;
  species?: string | null;
  description?: string | null;
  id: string | string;
};
export type SuggestionStatus =
  | "pending"
  | "applied"
  | "partially_applied"
  | "rejected";
export type SuggestionProvenanceStatus = "consistent" | "compromised";
export type SuggestionAction = "add_new" | "patch_existing" | "delete";
export type ReadSuggestionSummary = {
  id: string | string;
  created_at: string;
  modified_at: string;
  status: SuggestionStatus;
  provenance_status: SuggestionProvenanceStatus;
  action: SuggestionAction;
  target_id?: (string | string) | null;
  /** Number of supporting extractions (without loading them). */
  extraction_count: number;
};
export type ReadAnimalWithSuggestion = {
  short_description?: string | null;
  involvement_description?: string | null;
  name?: string | null;
  species?: string | null;
  description?: string | null;
  id: string | string;
  matter_id: string | string;
  created_at: string;
  modified_at: string;
  approval_metadata?: EntitySidecar;
  pending_suggestion?: ReadSuggestionSummary;
};
export type ReadEmployment = {
  acting_in_role_during_incident?: boolean;
  id: string | string;
  person_id: string | string;
  employer_id: string | string;
  created_at: string;
  modified_at: string;
};
export type CreateEmployment = {
  acting_in_role_during_incident?: boolean;
  person_id: string | string;
  employer_id: string | string;
};
export type UpdateEmployment = {
  acting_in_role_during_incident?: boolean;
  id: string | string;
};
export type SubjectOwnershipType = "owner" | "lessee" | "lessor";
export type ReadOwnership = {
  ownership_type: SubjectOwnershipType;
  id: string | string;
  party_id: string | string;
  subject_id: string | string;
  created_at: string;
  modified_at: string;
};
export type CreateOwnership = {
  ownership_type: SubjectOwnershipType;
  party_id: string | string;
  subject_id: string | string;
};
export type UpdateOwnership = {
  ownership_type?: SubjectOwnershipType;
  id: string | string;
};
export type PersonalRelationshipType =
  | "spouse"
  | "former_spouse"
  | "domestic_partner"
  | "child_of"
  | "parent_to"
  | "sibling"
  | "friend"
  | "legal_guardian"
  | "conservator"
  | "next_of_friend"
  | "next_of_kin"
  | "other";
export type ReadPersonalRelationship = {
  relationship_type: PersonalRelationshipType;
  notes?: string | null;
  id: string | string;
  from_person_id: string | string;
  to_person_id: string | string;
  created_at: string;
  modified_at: string;
};
export type CreatePersonalRelationship = {
  relationship_type: PersonalRelationshipType;
  notes?: string | null;
  from_person_id: string | string;
  to_person_id: string | string;
};
export type UpdatePersonalRelationship = {
  relationship_type?: PersonalRelationshipType;
  notes?: string | null;
  id: string | string;
};
export type PhysicalAddress = {
  line1?: string | null;
  line2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
};
export type RealPropertyType =
  | "residential"
  | "commercial"
  | "industrial"
  | "agricultural"
  | "mixed_use";
export type ReadProperty = {
  short_description?: string | null;
  involvement_description?: string | null;
  property_name?: string | null;
  physical_address?: PhysicalAddress;
  legal_description?: string | null;
  real_property_type: RealPropertyType;
  parcel_id?: string | null;
  id: string | string;
  matter_id: string | string;
  created_at: string;
  modified_at: string;
  approval_metadata?: EntitySidecar;
};
export type CreateProperty = {
  short_description?: string | null;
  involvement_description?: string | null;
  property_name?: string | null;
  physical_address?: PhysicalAddress;
  legal_description?: string | null;
  real_property_type: RealPropertyType;
  parcel_id?: string | null;
  matter_id: string | string;
};
export type UpdateProperty = {
  short_description?: string | null;
  involvement_description?: string | null;
  property_name?: string | null;
  physical_address?: PhysicalAddress;
  legal_description?: string | null;
  real_property_type?: RealPropertyType;
  parcel_id?: string | null;
  id: string | string;
};
export type PartyType = "person" | "organization";
export type IdentityStatus = "named" | "described" | "unknown";
export type ContactHandleType =
  | "PHONE"
  | "EMAIL"
  | "WEBSITE"
  | "FAX"
  | "OTHER"
  | "MAILING_ADDRESS";
export type WebSource = {
  /** The URL of the source */
  url: string;
  /** Very short display text for the source URL */
  title: string;
};
export type ContactHandleSchema = {
  id?: (string | string) | null;
  /** The captured contact information. Should contain an E.164 formatted phone number, or an email address, or a website, or a fax number. */
  value?: string | null;
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  handle_type: ContactHandleType;
  /** Short description of the handle; e.g. 'Billing Dept Toll-Free', 'Front Desk Fax' etc. */
  name?: string | null;
  /** Optional notes about the handle. */
  notes?: string | null;
  /** Citations for the handle. */
  sources?: WebSource[] | null;
  /** Whether this is the preferred contact handle. */
  preferred?: boolean | null;
  division_id?: (string | string) | null;
};
export type BodyPart =
  | "head"
  | "face"
  | "cervical_spine"
  | "shoulder_left"
  | "shoulder_right"
  | "arm_left"
  | "arm_right"
  | "elbow_left"
  | "elbow_right"
  | "wrist_left"
  | "wrist_right"
  | "hand_left"
  | "hand_right"
  | "chest"
  | "thoracic_spine"
  | "lumbar_spine"
  | "abdomen"
  | "hip_left"
  | "hip_right"
  | "leg_left"
  | "leg_right"
  | "knee_left"
  | "knee_right"
  | "ankle_left"
  | "ankle_right"
  | "foot_left"
  | "foot_right"
  | "other";
export type EntitySuggestionStatus = "suggested" | "accepted" | "rejected";
export type ReadInjury = {
  body_part: BodyPart;
  description?: string | null;
  id: string | string;
  person_id: string | string;
  approval_status?: EntitySuggestionStatus;
  created_at: string;
  modified_at: string;
};
export type ReadPerson = {
  party_type?: PartyType;
  is_claimant?: boolean;
  identity_status?: IdentityStatus;
  short_description?: string | null;
  involvement_description?: string | null;
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  first_name?: string | null;
  middle_name?: string | null;
  last_name?: string | null;
  suffix?: string | null;
  ssn?: string | null;
  date_of_birth?: string | null;
  stated_age?: number | null;
  is_minor?: boolean;
  gender?: string | null;
  preferred_language?: string | null;
  drivers_license_number?: string | null;
  drivers_license_state_code?: string | null;
  id: string | string;
  matter_id: string | string;
  created_at: string;
  modified_at: string;
  contact_handles?: ContactHandleSchema[];
  injuries?: ReadInjury[];
  approval_metadata?: EntitySidecar;
};
export type PersonalRelationshipWithPerson = {
  relationship_type: PersonalRelationshipType;
  notes?: string | null;
  id: string | string;
  from_person_id: string | string;
  to_person_id: string | string;
  created_at: string;
  modified_at: string;
  related_person: ReadPerson;
};
export type OrganizationType =
  | "corporation"
  | "trust"
  | "partnership"
  | "llc"
  | "llp"
  | "other";
export type ReadOrganization = {
  party_type?: PartyType;
  is_claimant?: boolean;
  identity_status?: IdentityStatus;
  short_description?: string | null;
  involvement_description?: string | null;
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  legal_name?: string | null;
  dba_name?: string | null;
  organization_type: OrganizationType;
  tax_id?: string | null;
  id: string | string;
  matter_id: string | string;
  created_at: string;
  modified_at: string;
  contact_handles?: ContactHandleSchema[];
  approval_metadata?: EntitySidecar;
};
export type EmploymentWithDetails = {
  acting_in_role_during_incident?: boolean;
  id: string | string;
  person_id: string | string;
  employer_id: string | string;
  created_at: string;
  modified_at: string;
  employer: ReadOrganization;
};
export type ReadPersonWithRelationships = {
  party_type?: PartyType;
  is_claimant?: boolean;
  identity_status?: IdentityStatus;
  short_description?: string | null;
  involvement_description?: string | null;
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  first_name?: string | null;
  middle_name?: string | null;
  last_name?: string | null;
  suffix?: string | null;
  ssn?: string | null;
  date_of_birth?: string | null;
  stated_age?: number | null;
  is_minor?: boolean;
  gender?: string | null;
  preferred_language?: string | null;
  drivers_license_number?: string | null;
  drivers_license_state_code?: string | null;
  id: string | string;
  matter_id: string | string;
  created_at: string;
  modified_at: string;
  contact_handles?: ContactHandleSchema[];
  injuries?: ReadInjury[];
  approval_metadata?: EntitySidecar;
  /** Outgoing personal relationships from this person. */
  personal_relationships?: PersonalRelationshipWithPerson[];
  /** Employment relationships for this person. */
  employments?: EmploymentWithDetails[];
};
export type ReadOrganizationWithEmployees = {
  party_type?: PartyType;
  is_claimant?: boolean;
  identity_status?: IdentityStatus;
  short_description?: string | null;
  involvement_description?: string | null;
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  legal_name?: string | null;
  dba_name?: string | null;
  organization_type: OrganizationType;
  tax_id?: string | null;
  id: string | string;
  matter_id: string | string;
  created_at: string;
  modified_at: string;
  contact_handles?: ContactHandleSchema[];
  approval_metadata?: EntitySidecar;
  /** People employed by this organization. */
  employees?: ReadPerson[];
};
export type OwnershipWithParty = {
  ownership_type: SubjectOwnershipType;
  id: string | string;
  party_id: string | string;
  subject_id: string | string;
  created_at: string;
  modified_at: string;
  party: ReadPersonWithRelationships | ReadOrganizationWithEmployees;
};
export type ReadPropertyWithOwners = {
  short_description?: string | null;
  involvement_description?: string | null;
  property_name?: string | null;
  physical_address?: PhysicalAddress;
  legal_description?: string | null;
  real_property_type: RealPropertyType;
  parcel_id?: string | null;
  id: string | string;
  matter_id: string | string;
  created_at: string;
  modified_at: string;
  approval_metadata?: EntitySidecar;
  owners?: OwnershipWithParty[];
};
export type ReadPropertyWithSuggestion = {
  short_description?: string | null;
  involvement_description?: string | null;
  property_name?: string | null;
  physical_address?: PhysicalAddress;
  legal_description?: string | null;
  real_property_type: RealPropertyType;
  parcel_id?: string | null;
  id: string | string;
  matter_id: string | string;
  created_at: string;
  modified_at: string;
  approval_metadata?: EntitySidecar;
  pending_suggestion?: ReadSuggestionSummary;
};
export type VehicleType =
  | "passenger_car"
  | "truck"
  | "motorcycle"
  | "bus"
  | "bicycle"
  | "scooter"
  | "skateboard"
  | "roller_skate"
  | "roller_blade"
  | "trailer"
  | "other";
export type ReadVehicle = {
  short_description?: string | null;
  involvement_description?: string | null;
  make?: string | null;
  model?: string | null;
  year?: number | null;
  color?: string | null;
  vin?: string | null;
  license_plate?: string | null;
  license_plate_state_code?: string | null;
  vehicle_type: VehicleType;
  estimated_speed_mph?: number | null;
  label_in_police_report?: string | null;
  id: string | string;
  matter_id: string | string;
  created_at: string;
  modified_at: string;
  approval_metadata?: EntitySidecar;
};
export type AllSubjectsResponse = {
  animals: ReadAnimal[];
  properties: ReadProperty[];
  vehicles: ReadVehicle[];
};
export type VehicleRole = "driver" | "passenger";
export type VehicleOccupancyWithPerson = {
  role: VehicleRole;
  id: string | string;
  person_id: string | string;
  vehicle_id: string | string;
  created_at: string;
  modified_at: string;
  person: ReadPersonWithRelationships;
};
export type ReadVehicleWithOccupants = {
  short_description?: string | null;
  involvement_description?: string | null;
  make?: string | null;
  model?: string | null;
  year?: number | null;
  color?: string | null;
  vin?: string | null;
  license_plate?: string | null;
  license_plate_state_code?: string | null;
  vehicle_type: VehicleType;
  estimated_speed_mph?: number | null;
  label_in_police_report?: string | null;
  id: string | string;
  matter_id: string | string;
  created_at: string;
  modified_at: string;
  approval_metadata?: EntitySidecar;
  occupants?: VehicleOccupancyWithPerson[];
};
export type AllSubjectsWithRelationships = {
  animals: ReadAnimal[];
  properties: ReadPropertyWithOwners[];
  vehicles: ReadVehicleWithOccupants[];
};
export type ReadVehicleOccupancy = {
  role: VehicleRole;
  id: string | string;
  person_id: string | string;
  vehicle_id: string | string;
  created_at: string;
  modified_at: string;
};
export type CreateVehicleOccupancy = {
  role: VehicleRole;
  person_id: string | string;
  vehicle_id: string | string;
};
export type UpdateVehicleOccupancy = {
  role?: VehicleRole;
  id: string | string;
};
export type CreateVehicle = {
  short_description?: string | null;
  involvement_description?: string | null;
  make?: string | null;
  model?: string | null;
  year?: number | null;
  color?: string | null;
  vin?: string | null;
  license_plate?: string | null;
  license_plate_state_code?: string | null;
  vehicle_type: VehicleType;
  estimated_speed_mph?: number | null;
  label_in_police_report?: string | null;
  matter_id: string | string;
};
export type UpdateVehicle = {
  short_description?: string | null;
  involvement_description?: string | null;
  make?: string | null;
  model?: string | null;
  year?: number | null;
  color?: string | null;
  vin?: string | null;
  license_plate?: string | null;
  license_plate_state_code?: string | null;
  vehicle_type?: VehicleType;
  estimated_speed_mph?: number | null;
  label_in_police_report?: string | null;
  id: string | string;
};
export type ReadVehicleWithSuggestion = {
  short_description?: string | null;
  involvement_description?: string | null;
  make?: string | null;
  model?: string | null;
  year?: number | null;
  color?: string | null;
  vin?: string | null;
  license_plate?: string | null;
  license_plate_state_code?: string | null;
  vehicle_type: VehicleType;
  estimated_speed_mph?: number | null;
  label_in_police_report?: string | null;
  id: string | string;
  matter_id: string | string;
  created_at: string;
  modified_at: string;
  approval_metadata?: EntitySidecar;
  pending_suggestion?: ReadSuggestionSummary;
};
export const {
  useAnimalsListQuery,
  useAnimalsCreateMutation,
  useAnimalsRetrieveQuery,
  useAnimalsUpdateMutation,
  useAnimalsDeleteMutation,
  useAnimalsApproveFieldMutation,
  useAnimalsWithSuggestionQuery,
  useEmploymentsListQuery,
  useEmploymentsCreateMutation,
  useEmploymentsRetrieveQuery,
  useEmploymentsUpdateMutation,
  useEmploymentsDeleteMutation,
  useOwnershipsListQuery,
  useOwnershipsCreateMutation,
  useOwnershipsRetrieveQuery,
  useOwnershipsUpdateMutation,
  useOwnershipsDeleteMutation,
  usePersonalRelationshipsListQuery,
  usePersonalRelationshipsCreateMutation,
  usePersonalRelationshipsRetrieveQuery,
  usePersonalRelationshipsUpdateMutation,
  usePersonalRelationshipsDeleteMutation,
  usePropertiesListQuery,
  usePropertiesCreateMutation,
  usePropertiesRetrieveQuery,
  usePropertiesUpdateMutation,
  usePropertiesDeleteMutation,
  usePropertiesApproveFieldMutation,
  usePropertiesWithOwnersQuery,
  usePropertiesWithSuggestionQuery,
  useAllSubjectsListQuery,
  useAllSubjectsWithRelationshipsQuery,
  useVehicleOccupanciesListQuery,
  useVehicleOccupanciesCreateMutation,
  useVehicleOccupanciesRetrieveQuery,
  useVehicleOccupanciesUpdateMutation,
  useVehicleOccupanciesDeleteMutation,
  useVehiclesListQuery,
  useVehiclesCreateMutation,
  useVehiclesRetrieveQuery,
  useVehiclesUpdateMutation,
  useVehiclesDeleteMutation,
  useVehiclesApproveFieldMutation,
  useVehiclesWithOccupantsQuery,
  useVehiclesWithSuggestionQuery,
} = injectedRtkApi;
